var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fc-notice" }, [
    _c("div", { staticClass: "fc-notice__container" }, [
      _vm.title
        ? _c(
            "h1",
            { staticClass: "fc-notice__title" },
            [
              _vm._l(_vm.stringParser(_vm.title), function (v, index) {
                return [_vm._v(" " + _vm._s(v)), _c("br", { key: index })]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subtitle
        ? _c(
            "div",
            { staticClass: "fc-notice__subtitle" },
            [
              _vm._l(_vm.stringParser(_vm.subtitle), function (v, index) {
                return [_vm._v(" " + _vm._s(v)), _c("br", { key: index })]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buttonText
        ? _c(
            "button",
            { staticClass: "fc-notice__button", on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.buttonText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelButtonText
        ? _c(
            "div",
            { staticClass: "fc-notice__text", on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.cancelButtonText))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }